<command-menu
  [filterPage]="filterPage"
  [showDottedMenu]="true"
  [inverted]="true"
  [showExport]="true"
  [canEditColumns]="false"
  (onExport)="saveTable()"
>
  <mat-checkbox class="desktop right-slot" color="primary" [checked]="showClosed" (change)="toggleShowClosedBudgets($event)">Show closed event budgets</mat-checkbox>
</command-menu>
<nested-table
  [items]="tableData"
  [filtersId]="filterPage"
  [condensedView]="condensed"
  [columns]="columnData"
  [readOnly]="true"
  [columnsById]="columnsById"
  [menuItems]="menuItems"
  [menuDisabled]="busy"
  [defaultSelectedColumnId]="budgetColumns.eventName"
  (selectItem)="openBudget($event)"
  (updatedSelectedIds)="selectIds($event)"
  [emptyMessage]="'No budgets in this account'"
></nested-table>